import RemoveLessonModal from './RemoveLessonModal';

export default RemoveLessonModal;
